import React from 'react'
import SystemDeviceFaults from './SystemDeviceFaults';
import Page from '../../common-components/Page';
import Grid from '@material-ui/core/Grid';
import * as strings from '../../helpers/strings';

const SystemDeviceFaultsDisplay = () => {
  return (

    <Page title={strings.lblSystemFault}>
    {/* <PaperContainer> */}
        <Grid container spacing={16}>
            <Grid item md={12} xs={12}>
                <SystemDeviceFaults/>
            </Grid>
        </Grid>
    {/* </PaperContainer> */}
</Page>
  )
}

export default SystemDeviceFaultsDisplay